<template>
  <v-row>
    <v-dialog v-model="showDialog" max-width="500px">
      <v-skeleton-loader v-if="loading" type="article, actions"></v-skeleton-loader>
      <v-card v-if="!loading">
        <v-card-title>
          <v-panel>      
              <span style="font-size: 20px">
                {{ $t("wkt.admin.projects.project.new_title") }}
              </span>
          </v-panel>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form">
              <v-row align="center">
                <v-col cols="12" class="d-flex align-center">
                  <div
                    :style="{
                      backgroundColor: convertColorToHex(data.color),
                      width: '22px',
                      height: '22px',
                      cursor: 'pointer',
                      border: '1px solid grey',
                      marginRight: '10px',
                    }"
                    @click="openColorDialog()" />
                  <v-text-field
                    v-model="data.shortName"
                    :label="$t('wkt.admin.projects.project.short_name')"
                    autocomplete="none"
                    :rules="[validationRules.required]"
                    maxLength="20"
                    counter="20" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field 
                    v-model="data.description" 
                    :label="$t('wkt.admin.projects.project.description')" 
                    autocomplete="none" 
                    :rules="[validationRules.required]" 
                    maxLength="250"
                    counter="250" />
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#185EA9" text @click="onSave()" style="font-size: 0.9em; font-weight: 400">
            {{ $t("wkt.admin.common.dialog-buttons.save").toUpperCase() }}
          </v-btn>
          <v-btn text @click="showDialog = false" style="font-size: 0.9em; font-weight: 400">
            {{ $t("wkt.admin.common.dialog-buttons.cancel").toUpperCase() }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ColorDialog ref='dlgColor' />
    <EditProjectDialog ref='dlgEdit' @show-alert="$emit('show-alert', $event)" @refresh="$emit('refresh', $event)" />
  </v-row>
</template>

<script>
import BaseModule from "../../common/BaseModule.js";
import ColorDialog from "../../common/ColorDialog.vue";
import EditProjectDialog from "./EditProjectDialog.vue";
import api from "../../../api/worktime.js";

export default {
  name: "CreateProjectDialog",
  mixins: [BaseModule],
  components: {
    ColorDialog, EditProjectDialog
  },
  data() {
    return {
      showDialog: false,
      loading: false,
      data: {}
    };
  },
  methods: {
		// eslint-disable-next-line no-unused-vars
    open(action, payload) {
      this.showDialog = true;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }

      this.data = {
        enabled: true,
        projectType: 0,
        color: 'red'
      };
    },
    openColorDialog() {
      this.$refs.dlgColor.open(this.data.color, (color) => {
        this.data.color = color;
      });
    },
    onSave() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.loading = true;

      api.createProject(this.data,
        (res) => {
          this.loading = false;
          if (res) {
            this.$emit("refresh");
            this.showDialog = false;
            this.$refs.dlgEdit.open('EDIT_PROJECT', res.id);
          } else {
            this.$emit("show-alert", { text: res.message, color: "error", timeout: 3000 });
          }
        },
        (error) => {
          this.loading = false;
          this.$log.error(error);
          this.$emit("show-alert", { text: error.message, color: "error", timeout: 3000 });
        }
      );
    }

  },
};
</script>
